import React from "react";
import image1 from "../../assets/Images/Gallery/image1.jpg";
import image2 from "../../assets/Images/Gallery/image2.jpg";
import image3 from "../../assets/Images/Gallery/image3.jpg";
import image4 from "../../assets/Images/Gallery/image4.jpg";
import image5 from "../../assets/Images/Gallery/image5.jpg";
import image6 from "../../assets/Images/Gallery/image6.jpg";
import image7 from "../../assets/Images/Gallery/image7.jpg";
import image8 from "../../assets/Images/Gallery/image8.jpg";
import image9 from "../../assets/Images/Gallery/image13.jpg";
import image10 from "../../assets/Images/Gallery/image14.png";
import image11 from "../../assets/Images/Gallery/image15.jpg";
import image12 from "../../assets/Images/Gallery/image16.webp";
import image13 from "../../assets/Images/Gallery/image17.jpg";
import image14 from "../../assets/Images/Gallery/image14.jpeg";
import image18 from "../../assets/Images/Gallery/image18.jpeg";
import image19 from "../../assets/Images/Gallery/image19.jpeg";
import image20 from "../../assets/Images/Gallery/image20.jpeg";
import image21 from "../../assets/Images/Gallery/image21.jpeg";
import image22 from "../../assets/Images/Gallery/image22.jpeg";
import image23 from "../../assets/Images/Gallery/image23.jpeg";
import image24 from "../../assets/Images/Gallery/image24.jpeg";
import image25 from "../../assets/Images/Gallery/image25.jpeg";
import image26 from "../../assets/Images/Gallery/image26.jpeg";
import image27 from "../../assets/Images/Gallery/image27.jpeg";
import image28 from "../../assets/Images/Gallery/image28.jpeg";
import image29 from "../../assets/Images/Gallery/image29.jpeg";
import image30 from "../../assets/Images/Gallery/image30.jpeg";
import image31 from "../../assets/Images/Gallery/image31.jpeg";
import image32 from "../../assets/Images/Gallery/image32.jpeg";
import image33 from "../../assets/Images/Gallery/image33.jpeg";
import image34 from "../../assets/Images/Gallery/image34.jpeg";
import image35 from "../../assets/Images/Gallery/image39.jpeg";
import image36 from "../../assets/Images/Gallery/image35.jpeg";
import image37 from "../../assets/Images/Gallery/image36.jpeg";
import image38 from "../../assets/Images/Gallery/image37.jpeg";
import image39 from "../../assets/Images/Gallery/image39.jpeg";
import image40 from "../../assets/Images/Gallery/image40.png";
import image41 from "../../assets/Images/Gallery/image41.png";
import image43 from "../../assets/Images/Gallery/image43.png";
import image44 from "../../assets/Images/Gallery/image44.png";
import image45 from "../../assets/Images/Gallery/image45.png";
import image46 from "../../assets/Images/Gallery/image46.png";
import image47 from "../../assets/Images/Gallery/image47.png";


import "tailwindcss/tailwind.css"; // Ensure Tailwind CSS is imported
import { Link } from "react-router-dom";

const Gallery = () => {
  const images = [
    image1,
    image2,
    image3,
    image4,
    image5,
    image6,
    image7,
    image8,
    image9,
    image10,
    image11,
    image12,
    image13,
    image14,
    image18,
    image19,
    image20,
    image21,
    image22,
    image23,
    image24,
    image25,
    image26,
    image27,
    image28,
    image29,
    image30,
    image31,
    image32,
    image33,
    image34,
    image35,
    image36,
    image37,
    image38,
    image39,
    image40,
    image41,
    image43,
    image44,
    image45,
    image46,
    image47,
  ];

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-2xl font-bold mb-4">Gallery</h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {images.map((image, index) => (
          <div key={index} className="gallery-item h-64 overflow-hidden">
            <img
              src={image}
              alt={`Gallery ${index + 1}`}
              className="w-full h-full object-cover rounded-lg hover:scale-105 transition-transform duration-300"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Gallery;
